<script setup lang="ts">
import { watchEffect } from 'vue'

import { useUiStore } from '@/stores/ui'

// Single source of truth for light/dark: tokens.css and the PrimeVue preset
// (plugins/primevue-theme.ts) both key off `<html data-theme="...">`.
const ui = useUiStore()

watchEffect(() => {
  document.documentElement.setAttribute('data-theme', ui.theme)
})
</script>

<template>
  <RouterView />
</template>
